import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import WishlistSuggestions from 'components/Wishlist/WishlistSuggestions';

import useWishlist from 'hooks/useWishlist';

import { useUser } from 'providers/UserProvider';

const CategoryWishlistSuggestions = ({ keywordsDisplay = [], ...rest }) => {
  const { offerWishlist } = useWishlist();
  const { loadingLoggedInUser } = useUser();
  const [keywordSuggestions, setKeywordSuggestions] = useState([]);

  useEffect(() => {
    if (!loadingLoggedInUser) {
      const alreadyAddedKeywords = offerWishlist?.items.map(
        ({ keywordDisplay }) => keywordDisplay
      );
      const notAddedKeywords = keywordsDisplay.filter(
        (keyword) => !alreadyAddedKeywords?.includes(keyword)
      );

      setKeywordSuggestions(notAddedKeywords);
    }
  }, [loadingLoggedInUser, keywordsDisplay]);

  return <WishlistSuggestions keywordsDisplay={keywordSuggestions} {...rest} />;
};

CategoryWishlistSuggestions.displayName = 'CategoryWishlistSuggestions';

CategoryWishlistSuggestions.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  headingProps: PropTypes.shape(),
  keywordButtonType: PropTypes.string,
  keywordButtonTypeCanChange: PropTypes.bool,
  keywordsDisplay: PropTypes.arrayOf(PropTypes.string),
  withEditWishlist: PropTypes.bool,
};

export default CategoryWishlistSuggestions;
